import React, { useState, useContext, useEffect } from "react"
import { WingsModal } from "@wingspans-ui"
import Form from "react-bootstrap/Form"
import { FirebaseContext } from "../Firebase"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCopy } from "@fortawesome/free-solid-svg-icons"
import { FormattedMessage, useIntl } from "react-intl"
import { useLocation } from "@reach/router"
import { sendStandardToast } from "../toasts/standard-toast"

const PortfolioShareModal = ({ show, togglePortfolioShareModal }) => {
  const [checked, setChecked] = useState(false)
  const { firebase, profile } = useContext(FirebaseContext)
  const location = useLocation()
  const { hostname } = location

  const { locale } = useIntl()

  const handleCheckboxChange = async (e) => {
    if (e.target.checked) {
      handleSubmit()
    } else {
      // Delete the public profile without confirmation
      const success = await firebase.makeProfilePrivate()
      if (!success) {
        console.error("couldnt set firebase public setting")
      } else {
        setChecked(false)
      }
    }
  }

  const handleSubmit = async () => {
    const success = await firebase.makeProfilePublic()
    if (!success) {
      setChecked(false)
    } else {
      setChecked(true)
    }
  }

  const publicPortfolioURL = `https://${hostname}${locale === "es-ES" ? "/es-ES" : ""}/profile/${profile.userId}`
  const publicPortfolioPath = `${locale === "es-ES" ? "/es-ES" : ""}/profile/${profile.userId}`

  const handleCopy = () => {
    navigator.clipboard.writeText(publicPortfolioURL)

    sendStandardToast({
      heading: <FormattedMessage id="portfolio-share-model-profile-link-copied" defaultMessage="Profile link copied to clipboard" />,
      type: "success",
    })
  }

  const handleViewPublicPortfolio = () => {
    if (typeof window !== "undefined") {
      window.open(publicPortfolioPath, "_blank", "noopener,noreferrer")
    }
  }

  useEffect(() => {
    // set the preview image to current image, once available
    if (profile && profile.profileIsPublic === true) {
      setChecked(true)
    }
  }, [profile])

  return (
    <WingsModal
      className="portfolio-share-modal"
      isOpen={show}
      onClose={() => togglePortfolioShareModal()}
      size="md"
      title={<FormattedMessage id="portfolio-share-model-profile-sharing" defaultMessage="Profile Sharing" />}
      titleLevel={5}
      primaryActionLabel={checked ? <FormattedMessage id="portfolio-share-model-view-public-portfolio" defaultMessage="View Public Portfolio" /> : null}
      onPrimaryAction={checked ? handleViewPublicPortfolio : undefined}
    >
      <WingsModal.Body>
        <div
          className="toggle-row"
          style={{
            backgroundColor: "whitesmoke",
            fontWeight: "bold",
          }}
        >
          <label style={{ fontWeight: "bold" }}>
            <FormattedMessage id="portfolio-share-model-profile-sharing-is-on" defaultMessage="Profile sharing is" />{" "}
            {checked ? <FormattedMessage id="switch-on" defaultMessage="ON" /> : <FormattedMessage id="switch-off" defaultMessage="OFF" />}
          </label>

          <Form.Check
            id={`portfolio-public-switch-toggle`}
            className="portfolio-toggle"
            type="switch"
            // label={isPublic ? "Public" : "Private"}
            checked={checked}
            onChange={(e) => handleCheckboxChange(e)}
          />
        </div>
        {checked && (
          <>
            <label style={{ textAlign: "left", marginBottom: "0.5rem" }}>
              <FormattedMessage id="portfolio-share-model-public-URL" defaultMessage="Public URL" />
            </label>
            <div className="w-flex w-flex-row w-items-center w-gap-1 w-mb-1">
              <input
                type="text"
                style={{
                  backgroundColor: "#fff",
                  fontSize: "14px",
                  width: "90%",
                  marginBottom: 0,
                }}
                defaultValue={publicPortfolioURL}
                disabled={true}
              />
              <button
                style={{ background: "none" }}
                type="button"
                onClick={handleCopy}
              >
                <FontAwesomeIcon color={"#40777C"} icon={faCopy} size="lg" />
              </button>
            </div>
          </>
        )}
      </WingsModal.Body>
    </WingsModal>
  )
}

export default PortfolioShareModal
